import { AspectRatio, Center } from "@chakra-ui/react";
import { GoogleMapsEmbed } from "@next/third-parties/google";

type Props = {
  address: string;
};

const api_key = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY;

const GoogleMap = (props: Props) => {
  const { address } = props;
  return (
    <AspectRatio borderColor={"gray.300"} borderWidth={"1px"} height={"300px"}>
      {api_key ? (
        <GoogleMapsEmbed
          apiKey={api_key}
          height={"100%"}
          width={"100%"}
          mode="place"
          q={address}
        />
      ) : (
        <Center height="100%" width="100%">
          Map is unavailable
        </Center>
      )}
    </AspectRatio>
  );
};

export default GoogleMap;
